import type { MatrixSelectionKey } from '../components/WorkJourneyMonthMatrixGrid';
import { getMatrixSelectionMeta, toggleMatrixSelectionKey } from './getMatrixSelectionMeta';

type MakeKey = (userId: string, date: string) => MatrixSelectionKey;

/**
 * Plain click on a future cell:
 * - empty / other user → start clean with that day
 * - same user → toggle the day (click-add / click-remove)
 *
 * Never mixes two users in one selection.
 */
export const applyFutureMatrixClickSelection = (
  previous: Set<MatrixSelectionKey>,
  userId: string,
  date: string,
  makeKey: MakeKey,
): Set<MatrixSelectionKey> => {
  const meta = getMatrixSelectionMeta(previous);
  if (!meta || meta.userId !== userId) {
    return new Set([makeKey(userId, date)]);
  }
  return toggleMatrixSelectionKey(previous, userId, date, makeKey);
};
